export default __webpack_public_path__ + "b6b9ef906eaf26b6f9191ba80bed87f4.png";